"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require(".");
class RandMat extends _1.Mat {
    constructor(rows, cols, mu, std) {
        super(rows, cols);
        _1.Utils.fillRandn(this.w, mu, std);
    }
}
exports.RandMat = RandMat;
//# sourceMappingURL=rand-mat.js.map